/* global axios */
import ApiClient from './ApiClient';

// Every call goes through the Rails backend. The dashboard never talks to an
// AI vendor directly and never receives an API key.
class AiAssistantAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  status(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_assistant/status`);
  }

  suggest(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_assistant/suggest`);
  }

  summarize(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_assistant/summarize`);
  }

  setAutoPaused(conversationId, paused) {
    return axios.post(
      `${this.url}/${conversationId}/ai_assistant/set_auto_paused`,
      { paused }
    );
  }

  logs(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_assistant/logs`);
  }

  feedback(conversationId, logId, finalText) {
    return axios.post(`${this.url}/${conversationId}/ai_assistant/feedback`, {
      log_id: logId,
      final_text: finalText,
    });
  }
}

class AiAssistantConfigAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/ai_assistant_config`);
  }

  update(inboxId, payload) {
    return axios.patch(`${this.url}/${inboxId}/ai_assistant_config`, {
      ai_assistant_config: payload,
    });
  }
}

export const aiAssistantConfigAPI = new AiAssistantConfigAPI();
export default new AiAssistantAPI();
